import { Column } from 'app/design/primitives/box';
import type { ReactElement } from 'react';
import type { NavigationScreen } from 'app/types/navigation';
import type { useProfile } from 'app/network/profile';
import type { useStatistics } from 'app/network/statistics';
import type { useProfileListingsData } from './shared';
import type { ProfileTab } from './profile-section-types';
import { ProfileTrustOverview } from './profile-trust';
import { ProfileListings } from './profile-listings';
import { FrequentedPlaces } from './frequented-places';

export function ProfileSectionContent({
  isPlace,
  profileTab,
  profileQuery,
  statisticsQuery,
  navigation,
  userId,
  isMyself,
  features,
  ratingsSection,
  listings,
  isLargeUI,
  onReviews,
}: {
  isPlace: boolean;
  profileTab: ProfileTab;
  profileQuery: ReturnType<typeof useProfile>;
  statisticsQuery: ReturnType<typeof useStatistics>;
  navigation: React.ComponentProps<NavigationScreen<'neighbour-profile'>>['navigation'];
  userId: string;
  isMyself: boolean;
  features: { ratings: boolean; places: boolean };
  ratingsSection: ReactElement;
  listings: ReturnType<typeof useProfileListingsData>;
  isLargeUI: boolean;
  onReviews: () => void;
}) {
  if (!isPlace) {
    if (profileTab === 'overview')
      return <ProfileTrustOverview {...{ profileQuery, statisticsQuery, navigation, userId, isMyself, onReviews }} />;
    if (profileTab === 'reviews') return features.ratings ? ratingsSection : null;
    if (profileTab === 'places')
      return features.places ? (
        <Column paddingTop="spacing.general.x4">
          <FrequentedPlaces places={profileQuery.data?.frequentedPlaces} />
        </Column>
      ) : null;
  }
  return (
    <ProfileListings
      isPlace={isPlace}
      place={{
        available: listings.placeAvailable,
        onTabChange: listings.setPlaceTab,
        ratings: ratingsSection,
        regulars: listings.placeRegulars,
        searchQuery: listings.searchQuery,
        setSearchQuery: listings.setSearchQuery,
        tab: listings.placeTab,
      }}
      neighbour={{
        isLargeUI,
        offers: listings.offers,
        requests: listings.requests,
        searchQuery: listings.searchQuery,
        setSearchQuery: listings.setSearchQuery,
        tab: listings.neighbourTab,
      }}
    />
  );
}
